import { render, staticRenderFns } from "./OrganizationScreen.vue?vue&type=template&id=bee1955e&scoped=true"
import script from "./OrganizationScreen.vue?vue&type=script&lang=js"
export * from "./OrganizationScreen.vue?vue&type=script&lang=js"
import style0 from "./OrganizationScreen.vue?vue&type=style&index=0&id=bee1955e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee1955e",
  null
  
)

export default component.exports